export default __webpack_public_path__ + "static/media/max-life-1.e69b0164.jpg";